import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const PRICING_POLICIES_LIST_QUERY = gql`
	query PricingPolicies($where: PricingPolicyViewModelFilterInput, $first: Int, $after: String) {
		pricingPolicies(where: $where, first: $first, after: $after) {
			nodes {
				pricingPolicyId
				name
				priority
				isActive
				tariffId
				scenario {
					scenarioId
					name
				}
				rate {
					rateId
					rateTypeEnum
					flatRateAmount
					rateSteps {
						rateStepId
						intervalMinutes
						intervalCharge
						maxIntervals
					}
				}
				overstayRate {
					rateId
					rateTypeEnum
					flatRateAmount
					rateSteps {
						rateStepId
						intervalMinutes
						intervalCharge
						maxIntervals
					}
				}
				limit {
					limitId
					minAmount
					maxAmount
					minStayMinutes
					maxStayMinutes
				}
				billingCycle {
					billingCycleId
					name
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const PRICING_POLICY_QUERY = gql`
	query PricingPolicy($id: Ulid!) {
		pricingPolicy(pricingPolicyId: $id) {
			pricingPolicyId
			name
			priority
			isActive
			tariffId
			activatedAt
			deactivatedAt
			scenario {
				scenarioId
				name
			}
			rate {
				rateId
				rateTypeEnum
				flatRateAmount
				rateSteps {
					rateStepId
					stepSequence
					intervalMinutes
					intervalCharge
					maxIntervals
				}
			}
			overstayRate {
				rateId
				rateTypeEnum
				flatRateAmount
				rateSteps {
					rateStepId
					stepSequence
					intervalMinutes
					intervalCharge
					maxIntervals
				}
			}
			limit {
				limitId
				minAmount
				maxAmount
				minStayMinutes
				maxStayMinutes
			}
			billingCycle {
				billingCycleId
				name
			}
		}
	}
`;

export const PRICING_POLICY_DELETE_MUTATION = gql`
	mutation DeletePricingPolicy($input: DeletePricingPolicyInput!) {
		deletePricingPolicy(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['pricingPolicies'] = {
	document: PRICING_POLICIES_LIST_QUERY,
	dataPath: 'pricingPolicies'
};

viewResourceQueryDefinitions['pricingPolicies'] = {
	document: PRICING_POLICY_QUERY,
	dataPath: 'pricingPolicy'
};

deleteResourceMutationDefinitions['pricingPolicies'] = {
	document: PRICING_POLICY_DELETE_MUTATION,
	operation: 'deletePricingPolicy',
	getVariables: variables => ({ input: variables })
};
